import ReactGA from 'react-ga';
import { getPageName, getQueryStringValues } from './withPath';
import {
  GA_DOC_DOWNLOAD,
  GA_CHECKLIST,
  GA_ACTION_CLICKED,
  GA_ACTION_OPEN,
  GA_ACTION_CLOSE,
  GA_ACTION_CHANGE,
  GA_CATEGORY_PRODUCT_SELECT,
  GA_CATEGORY_WIZARD_STEP,
  GA_MAIL_TO,
} from '../constants';

function getChecklistCategoryName(location) {
  const queryStringValues = getQueryStringValues(location);
  const productName = queryStringValues['product'];
  let pageName = getPageName(location);
  pageName = pageName === 'checklist' ? 'preinstallation' : pageName;
  return `${GA_CHECKLIST} ${pageName} ${productName}`;
}
export const getTrackingLabel = ({ location }) => {
  const pageName = getPageName(location);
  const qsValues = getQueryStringValues(location);
  let labelText = `product:${qsValues['product']};model:${qsValues['model']};page:${pageName}`;
  labelText += 'opt' in qsValues ? `;opt:${qsValues['opt']}` : '';
  return labelText;
};

export const getValueFromUrl = ({ location, fieldName }) => {
  const qsValues = getQueryStringValues(location);
  return qsValues[fieldName];
};

export const eventTracking = props => {
  const { evt, location, action } = props;
  let target = evt.target;
  let nodeName = target.nodeName;
  //Todo :to use getClose method
  if (['EM', 'SPAN'].includes(nodeName)) {
    target = target.parentNode;
    nodeName = target.nodeName;
  }
  const dataset = target.dataset;
  let dataTestId = dataset && dataset.testId ? dataset.testId : '';
  dataTestId = dataTestId.split('#')[0];
  const dataTitle = dataset && dataset.title ? dataset.title : '';
  let category = null;
  let gaAction = action ? action : GA_ACTION_CLICKED;
  let labelText = getTrackingLabel({ location });
  const checklistCategory = getChecklistCategoryName(location);
  const docName = target.innerText;
  switch (dataTestId) {
    case 'wc-link-wizard-step':
      category = GA_CATEGORY_WIZARD_STEP;
      labelText += `: ${dataTitle}`;
      break;
    case 'checklist-all-expand':
      category = checklistCategory;
      labelText += ': Expand All';
      gaAction = 'Expand All';
      break;
    case 'checklist-all-collapse':
      category = checklistCategory;
      labelText += ': Collapse All';
      gaAction = 'Collapse All';
      break;
    case 'checklist-row':
      category = checklistCategory;
      labelText += `: ${dataTitle}`;
      gaAction = 'Collapse';
      break;
    case 'checklist-box':
      category = checklistCategory;
      labelText += `: ${dataTitle}`;
      break;
    case 'doc-download-link':
    case 'title-download-link':
      category = GA_DOC_DOWNLOAD;
      labelText += `;doc:${docName}`;
      break;
    case 'email-link':
      category = GA_MAIL_TO;
      labelText += `;mail:${docName.replace('@', '&')}`;
      break;
    default:
      break;
  }

  // document download link
  // if (nodeName === 'A' && href && !category) {
  //   href = href.trim().toLowerCase();
  //   const fileExtension = (href.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
  //   const isHPESupportDoc = href.indexOf('.hpe.com/') !== -1;
  //   if (DOC_EXT_LIST.includes(fileExtension) || isHPESupportDoc) {
  //     labelText += `;doc:${docName}`;
  //     category = GA_DOC_DOWNLOAD;
  //   } else if (href.indexOf('mailto:') !== -1) {
  //     labelText += `;mail:${docName.replace('@', '&')}`;
  //     category = GA_MAIL_TO;
  //   }
  // }
  if (category) {
    ReactGA.event({
      action: gaAction,
      category: category,
      label: labelText,
    });
  }
};

//
export const trackAccordionShelf = options => {
  const { newIndexes, oldIndexes, list, location } = options;
  const checklistCategory = getChecklistCategoryName(location);

  let action = GA_ACTION_OPEN;
  let longArray = newIndexes;
  let shortArray = oldIndexes;
  if (oldIndexes.length > newIndexes.length) {
    action = GA_ACTION_CLOSE;
    longArray = oldIndexes;
    shortArray = newIndexes;
  }
  const index = longArray.filter(item => shortArray.indexOf(item) === -1)[0];
  const title = list[index].title;
  // const itemId = list[index].id;
  let labelText = getTrackingLabel({ location });
  labelText += `: Shelf-${title}`;
  ReactGA.event({
    category: checklistCategory,
    action: action,
    label: labelText,
  });
};

export const trackModelChange = ({ category, label }) => {
  ReactGA.event({
    action: GA_ACTION_CHANGE,
    category: category,
    label: label,
  });
};

export const trackProductSelect = product => {
  ReactGA.event({
    category: GA_CATEGORY_PRODUCT_SELECT,
    action: GA_ACTION_CLICKED,
    label: `${product}`,
  });
};
